const GetLoading = () => {
    return (
        <div>
            <h1>Waiting while the API call...</h1>
        </div>
    );
}
 
export default GetLoading;